import { IFederalLaw } from 'APIPackage/CatalogsModule/interfaces/IFederalLaw';
import { IFederalLawErvk } from 'APIPackage/CatalogsModule/interfaces/IFederalLawErvk';
import { DictionaryUUIDsEnum } from 'CorePackage/DictionariesModule/enums/DictionaryUUIDsEnum';
import { IDictionarySelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';

export const convertFederalLawToFormData = (
  initial: IFederalLaw | null,
): IDictionarySelectOption<IFederalLawErvk> | undefined => {
  if (!initial?.ervkUUID) return undefined;

  return {
    value: {
      dictVersionId: initial.ervkUUID,
      dictId: DictionaryUUIDsEnum.FEDERAL_LAWS,
    },
    id: initial.id?.toString(),
    code: initial.code,
    ervkId: initial.ervkUUID,
    number: initial.code,
    title: `${initial.code} - ФЗ`,
    label: `${initial.code} - ФЗ`,
    name: initial.name,
    date: '',
  };
};
